import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=c5bbfb68&"
import script from "./Lightbox.ts?vue&type=script&lang=ts&"
export * from "./Lightbox.ts?vue&type=script&lang=ts&"
import style0 from "@/components/admin/Lightbox.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports